import assertNever from "assert-never";
import React from "react";
import { STRINGS } from "../../strings";
import { TrainingCenterBundleItemMedia } from "../../system/AppState/AppStateTrainingCenter";
import { globalize, translate } from "../../translate";
import { ItemStatus } from "./TrainingCenterUtils";

interface Props {
  itemMedia: TrainingCenterBundleItemMedia;
  itemStatus: ItemStatus;
}

const TrainingCenterBundleItemSummary = (props: Props) => {
  switch (props.itemStatus) {
    case ItemStatus.LOCKED:
      return <span className="test-failed">{translate(STRINGS.NOT_AVAILABLE)}</span>;
    case ItemStatus.COMPLETE:
      return <span className="video-completed">{translate(STRINGS.COMPLETED)}</span>;
    case ItemStatus.EXEMPT:
      return (
        <span className="video-completed">{translate(STRINGS.YOU_ARE_EXEMPT_FROM_THIS_TEST)}</span>
      );
    case ItemStatus.TEST_FAILED:
      return <span className="test-failed">{translate(STRINGS.TEST_FAILED)}</span>;
    case ItemStatus.TEST_REQUIRED:
      return <span className="test-required">{translate(STRINGS.TEST_REQUIRED)}</span>;
    case ItemStatus.WATCH_REQUIRED:
      switch (props.itemMedia.type) {
        case "Video":
          return (
            <span className="watch-required">
              <span>{props.itemMedia.requiredWatchTimePercent}% </span>
              <span>{translate(STRINGS.REQUIRED)}</span>
            </span>
          );
        case "PDF":
          return (
            <span className="watch-required">
              <span>
                {globalize().formatUnit(props.itemMedia.requiredViewTimeMinutes, "minute", {
                  form: "short",
                })}{" "}
              </span>
              <span>{translate(STRINGS.REQUIRED)}</span>
            </span>
          );
        case "TestOnly":
          return <span className="test-required">{translate(STRINGS.TEST_REQUIRED)}</span>;
        default:
          return assertNever(props.itemMedia);
      }
    case ItemStatus.SUBMIT_REQUIRED:
      return <span className="submit-required">{translate(STRINGS.SUBMIT_REQUIRED)}</span>;
    case ItemStatus.SIGNATURE_REQUIRED:
      return <span className="signature-required">{translate(STRINGS.SIGNATURE_REQUIRED)}</span>;
    default:
      return assertNever(props.itemStatus);
  }
};

export default TrainingCenterBundleItemSummary;
